/* Логіка лендінга: галерея, вибір розміру й шнурків, шторки, липка панель,
   зворотний відлік і плашка соціального доказу — усе з макета Custom Sneaker
   Landing, але на звичайному DOM без React. */
(function () {
  var root = document.querySelector('[data-csl]');
  if (!root) return;

  var VARIANTS = [];
  try { VARIANTS = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { VARIANTS = []; }
  var MONEY = root.getAttribute('data-price') || '';
  var q = function (sel) { return root.querySelector(sel); };
  var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  var st = { size: null, lace: null, added: false };

  // ---------- варіанти ----------
  function laceNames() {
    var out = [];
    VARIANTS.forEach(function (v) { if (out.indexOf(v.lace) < 0) out.push(v.lace); });
    return out;
  }
  function findVariant() {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].size === st.size && VARIANTS[i].lace === st.lace) return VARIANTS[i];
    }
    return null;
  }
  function sizeAvailable(size) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].size === size && VARIANTS[i].lace === st.lace && VARIANTS[i].available) return true;
    }
    return false;
  }

  // ---------- галерея ----------
  var track = q('[data-csl-track]');
  var dots = qa('[data-csl-dot]');
  var thumbs = qa('[data-csl-thumb]');
  var num = q('[data-csl-num]');

  function slideCount() { return track ? track.children.length : 0; }
  function currentSlide() {
    if (!track || !track.clientWidth) return 0;
    return Math.round(track.scrollLeft / track.clientWidth);
  }
  function paintGallery() {
    var i = currentSlide();
    dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    if (num) num.textContent = (i + 1) + ' / ' + slideCount();
  }
  function goSlide(i) {
    if (!track) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  if (track) {
    track.addEventListener('scroll', paintGallery, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goSlide(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goSlide(i); }); });
    paintGallery();
  }

  // ---------- шнурки ----------
  function pickLace(name) {
    if (st.lace === name) return;
    st.lace = name;
    qa('[data-csl-lace]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-csl-lace') === name ? 'true' : 'false');
    });
    var hint = q('[data-csl-lacehint]');
    if (hint) hint.textContent = name;
    toast(name + ' selected');
    paintSizes();
    paintCta();
  }
  qa('[data-csl-lace]').forEach(function (b) {
    b.addEventListener('click', function () { pickLace(b.getAttribute('data-csl-lace')); });
  });

  // ---------- розміри ----------
  function pickSize(size) {
    st.size = size;
    qa('[data-csl-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-csl-size') === size ? 'true' : 'false');
    });
    closeSheet();
    paintCta();
  }
  function paintSizes() {
    qa('[data-csl-size]').forEach(function (b) {
      var s = b.getAttribute('data-csl-size');
      var ok = sizeAvailable(s);
      b.disabled = !ok;
      if (!ok && st.size === s) { st.size = null; b.setAttribute('aria-pressed', 'false'); }
    });
  }
  qa('[data-csl-size]').forEach(function (b) {
    b.addEventListener('click', function () { if (!b.disabled) pickSize(b.getAttribute('data-csl-size')); });
  });

  // ---------- кнопка ----------
  var cta = q('[data-csl-cta]');
  var ctaLabel = q('[data-csl-ctalabel]');
  var barCta = q('[data-csl-barcta]');
  var barSize = q('[data-csl-barsize]');
  var picked = q('[data-csl-picked]');
  var stock = q('[data-csl-stock]');
  var panelCta = q('[data-csl-panelcta]');

  function paintCta() {
    var v = findVariant();
    var ready = !!v && v.available;
    if (cta) cta.disabled = !ready;
    if (panelCta) panelCta.disabled = !ready;
    var label = st.added ? 'Added to cart' : ready ? ('Add to cart — ' + MONEY) : 'Select your size';
    if (ctaLabel) ctaLabel.textContent = label;
    if (cta) cta.classList.toggle('is-added', st.added);
    if (barCta) {
      barCta.textContent = st.added ? 'Added' : ready ? ('Add — ' + MONEY) : 'Select size';
      // кнопка більше не disabled: без розміру вона веде до сітки розмірів
      barCta.classList.toggle('is-need', !ready && !st.added);
      barCta.classList.toggle('is-added', st.added);
    }
    if (barSize) barSize.textContent = st.size ? (st.size + ' · ' + st.lace) : 'No size selected';
    if (picked) {
      picked.textContent = st.size ? ('Selected size: ' + st.size) : 'Select a size to continue';
      picked.classList.toggle('is-set', !!st.size);
    }
    if (stock) stock.textContent = st.size ? 'Your size is available' : 'Most sizes available today';
    var input = q('[data-csl-variant]');
    if (input && v) input.value = v.id;
  }

  function addToCart() {
    var v = findVariant();
    if (!v || !v.available) return;
    var form = q('[data-csl-form]');
    if (!form) return;
    st.added = true;
    paintCta();
    form.submit();
  }
  // Розмір ще не обрано: на десктопі скролимо до сітки розмірів і підсвічуємо її,
  // на мобільному відкриваємо рідну шторку розмірів (як сусідня кнопка «No size selected»).
  function goToSizes() {
    var wide = window.matchMedia && window.matchMedia('(min-width:900px)').matches;
    var grid = q('[data-csl-sizegrid]');
    if (!wide || !grid) { openSheet(); return; }
    var y = grid.getBoundingClientRect().top + (window.pageYOffset || 0) - 150;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    grid.classList.add('is-pulse');
    setTimeout(function () { grid.classList.remove('is-pulse'); }, 1400);
  }

  if (cta) cta.addEventListener('click', addToCart);
  if (barCta) barCta.addEventListener('click', function () {
    var v = findVariant();
    if (v && v.available) addToCart(); else goToSizes();
  });
  if (panelCta) panelCta.addEventListener('click', addToCart);

  // ---------- шторки ----------
  var sheet = q('[data-csl-sheet]');
  function openSheet() { if (sheet) sheet.hidden = false; }
  function closeSheet() { if (sheet) sheet.hidden = true; }
  qa('[data-csl-opensheet]').forEach(function (b) { b.addEventListener('click', openSheet); });
  qa('[data-csl-closesheet]').forEach(function (b) { b.addEventListener('click', closeSheet); });

  var rSheet = q('[data-csl-reviews]');
  qa('[data-csl-openreviews]').forEach(function (b) {
    b.addEventListener('click', function () { if (rSheet) rSheet.hidden = false; });
  });
  qa('[data-csl-closereviews]').forEach(function (b) {
    b.addEventListener('click', function () { if (rSheet) rSheet.hidden = true; });
  });

  var zoom = q('[data-csl-zoom]');
  qa('[data-csl-openzoom]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!zoom) return;
      var img = zoom.querySelector('img');
      var cur = track && track.children[currentSlide()];
      var src = cur && cur.querySelector('img');
      if (img && src) img.src = src.currentSrc || src.src;
      zoom.hidden = false;
    });
  });
  if (zoom) zoom.addEventListener('click', function () { zoom.hidden = true; });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSheet();
    if (rSheet) rSheet.hidden = true;
    if (zoom) zoom.hidden = true;
  });

  // ---------- підказка над галереєю ----------
  function toast(text) {
    var host = q('[data-csl-toasthost]');
    if (!host) return;
    var old = host.querySelector('.csl-toast');
    if (old) old.remove();
    var n = document.createElement('div');
    n.className = 'csl-toast';
    n.textContent = text;
    host.appendChild(n);
    setTimeout(function () { if (n.parentNode) n.remove(); }, 1900);
  }

  // ---------- відлік, прогрес, липка панель ----------
  var total = 4 * 3600 + 12 * 60;
  var t0 = Date.now();
  function paintClock() {
    var n = q('[data-countdown]');
    if (!n) return;
    var left = Math.max(0, total - Math.floor((Date.now() - t0) / 1000));
    n.textContent = Math.floor(left / 3600) + 'h ' + Math.floor((left % 3600) / 60) + 'm '
      + String(left % 60).padStart(2, '0') + 's';
  }
  // ---------- блок конструктора: три фото ----------
  // Раніше підписи й смужки крутила CSS-анімація, а фото було одне. Тепер
  // слайдами керує JS, щоб кружечки могли перемикати їх кліком.
  var cust = q('[data-csl-cust]');
  if (cust) {
    var cIms = qa('[data-csl-cust-im]');
    var cLists = [cIms, qa('[data-csl-cust-chip]'), qa('[data-csl-cust-cap]'), qa('[data-csl-cust-seg]')];
    var cI = 0, cTimer = null;

    var cStage = cust.querySelector('.csl-cust__img');

    // Фото залиті з різним студійним фоном, тож плашку підганяємо під кожне:
    // усереднюємо верхні кути (там завжди фон, не кросівок) і фарбуємо нею
    // поля навколо. Не хардкод — переживає заміну фото в редакторі.
    var sampleBg = function (img) {
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return '';
        var cv = document.createElement('canvas');
        cv.width = 2; cv.height = 1;
        var ctx = cv.getContext('2d');
        var pad = Math.max(1, Math.round(w * 0.06));
        ctx.drawImage(img, 0, 0, pad, pad, 0, 0, 1, 1);              // лівий верхній кут
        ctx.drawImage(img, w - pad, 0, pad, pad, 1, 0, 1, 1);        // правий верхній
        var d = ctx.getImageData(0, 0, 2, 1).data;
        if (d[3] < 200 || d[7] < 200) return '';                     // прозорий PNG — не чіпаємо
        return 'rgb(' + Math.round((d[0] + d[4]) / 2) + ','
                      + Math.round((d[1] + d[5]) / 2) + ','
                      + Math.round((d[2] + d[6]) / 2) + ')';
      } catch (e) {
        return '';                                                   // canvas tainted — лишаємо --stage
      }
    };

    var paintCust = function () {
      cLists.forEach(function (list) {
        list.forEach(function (el, n) {
          if (n === cI) el.classList.add('is-on'); else el.classList.remove('is-on');
        });
      });
      var bg = cIms[cI] && cIms[cI].getAttribute('data-bg');
      if (cStage && bg) cStage.style.backgroundColor = bg;
    };

    cIms.forEach(function (im) {
      var take = function () {
        var bg = sampleBg(im);
        if (bg) { im.setAttribute('data-bg', bg); paintCust(); }
      };
      if (im.complete && im.naturalWidth) take(); else im.addEventListener('load', take);
    });
    var autoCust = function () {
      clearInterval(cTimer);
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (cIms.length > 1 && !still) {
        cTimer = setInterval(function () { cI = (cI + 1) % cIms.length; paintCust(); }, 2600);
      }
    };
    cLists[1].forEach(function (chip, n) {
      chip.addEventListener('click', function () { cI = n; paintCust(); autoCust(); });
    });
    paintCust();
    autoCust();
  }

  var proofDone = false;
  function paintScroll() {
    var sc = document.scrollingElement || document.documentElement;
    var top = Math.max(sc.scrollTop || 0, window.scrollY || 0);
    var max = Math.max(1, (sc.scrollHeight || 0) - (sc.clientHeight || window.innerHeight));
    var prog = q('[data-progress]');
    if (prog) prog.style.width = Math.min(100, Math.round(top / max * 100)) + '%';

    var anchor = q('[data-csl-anchor]');
    var show = anchor ? anchor.getBoundingClientRect().bottom < 0 : top > 900;
    var bar = q('[data-csl-bar]');
    if (bar) bar.style.transform = show ? 'translateY(0)' : 'translateY(130%)';
    var pill = q('[data-csl-proof]');
    if (pill && !proofDone && top > 700) {
      proofDone = true;
      pill.style.display = 'flex';
      pill.style.animation = 'cslSlideIn .4s cubic-bezier(.2,.8,.2,1)';
      setTimeout(function () { pill.style.display = 'none'; }, 6000);
    }
  }
  var pill = q('[data-csl-proof]');
  if (pill) pill.addEventListener('click', function () { pill.style.display = 'none'; });

  document.addEventListener('scroll', paintScroll, true);
  window.addEventListener('resize', function () { paintScroll(); paintGallery(); });
  setInterval(function () { paintClock(); paintScroll(); }, 500);

  // ---------- старт ----------
  var laces = laceNames();
  if (laces.length) pickLace(laces[laces.length - 1]);   // у макеті типово шнурки з реклами
  paintSizes();
  paintCta();
  paintClock();
  paintScroll();
})();
